export default {
      id: "number-of-visitors-usage",
      viewBox: "0 0 42 44",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#number-of-visitors",
      toString: function () {
        return this.url;
      }
    }